<template>
	<div>

		<v-app-bar
      color="white"
    >

      <v-toolbar-title class="ml-12">
				<router-link to="/">
					<h2 class="grey--text"><v-icon class="elcolor">mdi-web</v-icon> sitios<span class="elcolor">.</span>co</h2>
				</router-link>
			</v-toolbar-title>

      <v-spacer></v-spacer>

			<h4>Dominios</h4>
			<h4>Alojamiento web</h4>
			<h4>Correo electrónico</h4>
			<h4><router-link to="/precios">Precios</router-link></h4>
			<v-menu bottom offset-y :close-on-content-click="false">
				<template v-slot:activator="{ on, attrs }">
					<h4 class="elcolor" style="cursor: pointer" v-on="on" v-bind="attrs">Mi cuenta</h4>
				</template>

				<v-card>

					<v-progress-linear
						v-if="!$root.autenticación.cargaInicial"
						vvv-if="true"
						color="deep-purple accent-4"
						indeterminate
						rounded
						height="6"
					></v-progress-linear>

					<ingreso
						v-else-if="$root.autenticación.cargaInicial && (!$root.usuario || !$root.usuario.identificador || !$root.cuenta || !$root.cuenta.identificador)"
						style="min-width: 300px"
						@ingresar="alIngresar"
					></ingreso>

					<v-card
						v-else-if="$root.autenticación.cargaInicial && $root.usuario && $root.usuario.identificador && $root.cuenta && $root.cuenta.identificador"
						ccclass="pa-4"
					>
						
						<v-card-title class="text-h6 font-weight-regular">Hola, {{ $root.usuario.nombres }}</v-card-title>
						<v-card-subtitle>{{ $root.cuenta.nombre }}</v-card-subtitle>

						<v-divider></v-divider>

						<v-card-text>
							<p class="subtitle-1"><router-link to="administración">Ingresar al panel de administración</router-link></p>
							<v-btn class="ma-2" tile color="blue-grey" dark @click="$root.firebase.auth().signOut()">Cerrar sesión</v-btn>
						</v-card-text>

					</v-card>

					<div v-else><p>Error: 2398</p></div>

				</v-card>
			</v-menu>

    </v-app-bar>

		<v-main>
      <v-container
        class="fill-height pa-0"
        fluid
      >

        <router-view></router-view>

      </v-container>
    </v-main>

    <v-footer
      color="#26313c"
			class="pa-6 d-flex flex-column"
    >
			<div class="white--text">
				<a href="https://wa.me/%2B573042010204" target="_blank" title="Enviar un mensaje por Whatsapp" class="white--text">
					<img src="/img/whatsapp-24x24.svg" style="vertical-align: middle"><span>&nbsp;&nbsp;+57 304 201 0204</span>
				</a>
				<span class="mx-4">|</span>
				<a href="tel:+573042010204" title="Hacer una llamada telefónica" class="white--text">
					<v-icon class="elcolor">mdi-phone</v-icon><span>&nbsp;&nbsp;+57 304 201 0204</span>
				</a>
				<span class="mx-4">|</span>
				<a href="mailto:contacto@sitios.co" title="Escribir un correo electrónico" class="white--text">
					<v-icon class="elcolor">mdi-email</v-icon><span>&nbsp;&nbsp;contacto@sitios.co</span>
				</a>
			</div>
			<div class="mt-6">
				<span class="white--text" style="width: 100%">sitios.co &copy; {{ new Date().getFullYear() }}</span>
			</div>
    </v-footer>

	</div>
</template>


<script>

import ingreso from '@/views/ingreso';

export default {
	name: 'raiz',
	components: {
		ingreso
	},
	methods: {
		alIngresar: function() {
			window.setTimeout( () => {
				this.$router.push('/administración')
			}, 500)
		}
	}
}

</script>


<style scoped>

.v-toolbar__content > h4 {
	margin-right: 20px;
	font-weight: 400;
	white-space: nowrap;
}

.v-toolbar__content > h4:last-child {
	margin-right: 60px;
}

</style>